<template>
  <div :class="`booking-element--error ${type}`">
    <img src="/images/icons_svg/info-icon.svg"></img>{{$t(`booking.element_errors.${msg}`, this.msgOptions)}}
  </div>

</template>

<script>
export default {
  props: ['msg', 'msgOptions', "type"]
}
</script>

<style lang="scss" scoped>

</style>